<template>
    <v-app id="backGND">
        <navBar />
      <div id="triangle_down">
        <div id="triangle">
          <h1
            class="rotate"
            style="
              margin: auto;
              text-align: left;
              font-family: 'Poiret One', sans-serif;
              color: white;
              padding-left: 1rem;
              font-size: 3rem;
            "
          >
             DECLARACIÓN DE PRIVACIDAD
          </h1>
          
        </div>
      </div>
      <v-responsive style="padding-bottom: 200px;">
            <v-card color="rgba(0, 0, 0, 0)" elevation="0" class="justify-center">
            <div style="margin: auto; width: 70%;   text-align: justify; text-justify: inter-word;">
                <p style="font-size: 2rem; "><b>
                    SECCIÓN 1 - ¿QUÉ HACEMOS CON TU INFORMACIÓN?
                    <br/>
                    Cuando te registras en nuestra página, como parte del proceso nosotros recolectamos la información personal que nos
                    das tales como nombre, dirección y correo electrónico.
                    <br/>
                    <br/>
                    SECCIÓN 2 - CONSENTIMIENTO
                    <br/>
                    ¿Cómo obtienen mi consentimiento?<br/>
                    Cuando nos provees tu información personal para completar una transacción, crear una órden, implicamos que aceptas la recolección y uso por esa razón específica solamente.
                    Si te pedimos tu información personal por una razón secundaria, como marketing, te pediremos directame tu expreso consentimiento, o te daremos la oportunidad de negarte.
                    ¿Cómo puedo anular mi consentimiento? <br/>                   
                    Si luego de haber aceptado cambias de opinión, puedes anular tu consentimiento para que te contactemos, por la recolección, uso o divulgación de tu información, en cualquier momento, contactándonos a barreprodgo@gmail.com.
                    <br/>
                    <br/>
                    SECCIÓN 3 - DIVULGACIÓN
                    <br/>
                    Podemos divulgar tu información personal si se nos requiere por ley.

                    <!-- <br/>
                    SECCIÓN 4 - SHOPIFY
                    <br/>
                    Nuestra página se encuentra alojada en Shopify Inc. Ellos nos proporcionan la plataforma de comercio electrónico en línea que nos permite venderte nuestros productos y servicios.
                    Tus datos se almacenan a través del almacenamiento de datos de Shopify, bases de datos y la aplicación general de Shopify. Tus datos se almacenan en un servidor seguro detrás de un firewall.
                    <br/>
                    Payment:
                    <br/>
                    Si eliges una pasarela de pago directo para completar tu compra, entonces Shopify almacena datos de tu tarjeta de crédito. Está cifrada a través de la Seguridad Standard de Datos de la Industrai de Tarjetas de Pago (PCI-DSS). Tus datos de transacción de compra se almacenan sólo en la medida en que sea necesario para completar la transacción de compra. Después de que se haya completado, se borra la información de su transacción de compra.
                    Todas las pasarelas de pago directo se adhieren a los estándares establecidos por PCI-DSS como lo indicado por el Consejo de Normas de Seguridad de PCI, que es un esfuerzo conjunto de marcas como Visa, MasterCard, American Express y Discover.
                    Los requisitos del PCI-DSS ayudan a garantizar el manejo seguro de la información de tarjetas de crédito de las tiendas y sus proveedores de servicios.
                    Para una visión más clara, es posible que también desees leer las Condiciones de servicio de Shopify aquí o Declaración de privacidad aquí. -->

                    <br/>
                    <br/>
                    SECCIÓN 4 - SEGURIDAD
                    <br/>
                    Para proteger tu información personal, tomamos precauciones razonables y seguimos las mejores prácticas de la industria para asegurarnos de que no haya pérdida de manera inapropiada, mal uso, acceso, divulgación, alteración o destrucción de la misma.
                    <!-- SI nos proporcionas la información de tu tarjeta de crédito, dicha información es encriptada mediante la tecnología Secure Socket Layer (SSL) y se almacena con un cifrado AES-256. Aunque ningún método de transmisión a través de Internet o de almacenamiento electrónico es 100% seguro, seguimos todos los requisitos de PCI-DSS e implementamos normas adicionales aceptadas por la industria.
                    COOKIES -->

                    <!-- Aquí tienes una lista de cookies que utilizamos. Las enlistamos para que puedas elegir si quieres optar por quitarlas o no.
                    _session_id, unique token, sessional, Allows Shopify to store information about your session (referrer, landing page, etc).
                    _shopify_visit, no data held, Persistent for 30 minutes from the last visit, Used by our website provider’s internal stats tracker to record the number of visits
                    _shopify_uniq, no data held, expires midnight (relative to the visitor) of the next day, Counts the number of visits to a store by a single customer.
                    cart, unique token, persistent for 2 weeks, Stores information about the contents of your cart.
                    _secure_session_id, unique token, sessional
                    storefront_digest, unique token, indefinite If the shop has a password, this is used to determine if the current visitor has access. -->

                    <br/>
                    <br/>
                    SECCIÓN 5 - EDAD DE CONSENTIMIENTO
                    <br/>
                    Al utilizar este sitio, declaras que tienes al menos la mayoría de edad en tu estado o provincia de residencia, o que tienes la mayoría de edad en tu estado o provincia de residencia y que nos has dado tu consentimiento para permitir que cualquiera de tus dependientes menores use este sitio.

                    <br/>
                    <br/>
                    SECCIÓN 6 - CAMBIOS A ESTA POLÍTICA DE PRIVACIDAD
                    <br/>
                    Nos reservamos el derecho de modificar esta política de privacidad en cualquier momento, asique por favor revísala frecuentemente. Cambios y aclaraciones entrarán en vigencia inmediatamente después de su publicación en el sitio web. Si hacemos cambios materiales a esta política, notificaremos aquí que ha sido actualizada, por lo que cual estás enterado de qué información recopilamos, cómo y bajo qué circunstancias, si las hubiere, la utilizamos y/o divulgamos.
                    Si nuestra página es adquirida o fusionada con otra empresa, tu información puede ser transferida a los nuevos propietarios, para que podamos seguir vendiéndote productos.


                    <br/>
                    <br/>
                    PREGUNTAS E INFORMACIÓN DE CONTACTO
                    <br/>

                    Si quieres: acceder, corregir, enmendar o borrar cualquier información personal que poseamos sobre ti, registrar una queja, o simplemente quieres más información contacta a nuestro Oficial de Cumplimiento de Privacidad barreprodgo@gmail.com
                    Mimosa 140, Jardines de Durango, Durango.</b>
                </p>
            </div>
            </v-card>
        </v-responsive>
        <foot />
    </v-app>
  </template>
  <script>

import foot from "@/components/footer";
import navBar from "@/components/navbar";
  export default {
      components: { navBar, foot }
  };
  </script>
  <style scoped>
  #backGND {
    background-image: url("../assets/back.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    margin-top: auto;
  }
  #triangle_down {
    height: 10rem;
  
    background: linear-gradient(
      to top right,
      rgba(255, 0, 0, 0) 0%,
      rgba(255, 0, 0, 0) 50%,
      rgba(200, 200, 200, 1) 50%,
      rgba(200, 200, 200, 1) 100%
    );
  }
  #triangle {
    height: 10rem;
    background: linear-gradient(
      to top left,
      rgba(255, 0, 0, 0) 0%,
      rgba(255, 0, 0, 0) 50%,
      #000000 50%,
      #000000 100%
    );
  }
  .rotate {
    transform: rotate(-5deg);
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/privacidad.vue